export { assessmentSchedule } from '../libs/application/helpers/types'

export const assessmentEndpoints = {
  getAssessments: { method: 'get', path: '/' },
  listAssessmentsPaginated: { method: 'post', path: '/list' },
  createAssessment: { method: 'post', path: '/' },
  sendAssessment: { method: 'post', path: '/{id}/send' },
  updateAssessment: { method: 'post', path: '/{id}/update' },
  deleteAssessment: { method: 'post', path: '/{id}/delete' },
  getAssessmentStats: { method: 'get', path: '/get-stats' },
  uploadAssessments: { method: 'post', path: '/upload' },
} as const
